import React, { useState, useMemo } from 'react';
import styled from 'styled-components';
import { Page } from '@4beefopag/4bee-fopag-core/dist/organisms';
import PresetReports from '../../organisms/PresetReports';
import TitlePage from '../../atoms/TitlePage';
import { reportTypes, categories } from './reportData';

const SectionPadding = styled.div`
  margin-left: 20px;
  padding: 24px;
  background-color: #fff;
  min-height: 450px;
`;

export default function PresetReport() {
  const [searchValue, setSearchValue] = useState('');
  const [reportTypeValue, setReportTypeValue] = useState(undefined);

  const categoriesMemo = useMemo(() => categories, []);

  return (
    <Page
      projeto="Cooperativa"
      titulo="Relatórios Pré-Definidos"
      linkManual={process.env.REACT_APP_LINK_MANUAL}
    >
      <SectionPadding>
        <TitlePage title="Relatórios Pré-Definidos" />
        <PresetReports
          searchValue={searchValue}
          onSearchChange={setSearchValue}
          reportTypeValue={reportTypeValue}
          onReportTypeChange={setReportTypeValue}
          reportTypes={reportTypes}
          categories={categoriesMemo}
        />
      </SectionPadding>
    </Page>
  );
}
